<section id="pageCover" class="row">
    <img src="../../../assets/images/contactCover.png" alt="" class="pageCover">
    <!--<div class="row pageTitle">Projects</div>-->
    <div class="row pageBreadcrumbs">
        <!--<ol class="breadcrumb">
            <li><a href="index.html">home</a></li>
            <li class="active">Projects</li>
        </ol>-->
    </div>
</section>

<section id="projectsRow" class="row fullWidth col3 page">
    <div class="container">
        <div class="row">
            <div class="row filtersRow m0">
                <button type="button" class="collapsed project_filderButton visible-xs" data-toggle="collapse" data-target="#filters">
                    <span class="btn-text"><i class="fa fa-filter"></i> Project Filter</span>
                </button>
                <ul class="list-inline text-center collapse navbar-collapse filters" id="filters">
                    <li class="active" data-filter="*"><i class="fa fa-th"></i>{{'ShowAll' | translate}}</li>
                    <li data-filter=".PMO">PMO</li>
                    <li data-filter=".DPM">{{'DevelopProjectManagement' | translate}}</li>
                    <li data-filter=".PM">{{'ProjectManagement' | translate}}</li>
                    <li data-filter=".CM">{{'ConstructionManagement' | translate}}</li>
                    <li data-filter=".GB">{{'GreenBuildings' | translate}}</li>
                    <li data-filter=".FM">{{'FacilityManagement' | translate}}</li>
                    <li data-filter=".VOR">{{'VOR2030' | translate}}</li>
                </ul>
            </div>
            <div class="row projects m0" id="container">
                <div class="project PMO">
                    <a href="../../../assets/images/projects/project1.png" data-lightbox="project" data-title="Establish PMO Office for Municipal Projects">
                        <img src="../../../assets/images/projects/project1.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName">Establish PMO Office for Municipal Projects</div>
                            <div class="row m0 projectType">PMO</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project1.png" data-lightbox="project" data-title="Establish PMO Office for Municipal Projects" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=1" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
                <div class="project PMO">
                    <a href="../../../assets/images/projects/project2.png" data-lightbox="project" data-title="Establish & Operate PMO for Makkah Municipality">
                        <img src="../../../assets/images/projects/project2.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName">Establish & Operate PMO for Makkah Municipality</div>
                            <div class="row m0 projectType">PMO</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project2.png" data-lightbox="project" data-title="Establish & Operate PMO for Makkah Municipality" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=2" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
                <div class="project DPM">
                    <a href="../../../assets/images/projects/project3.png" data-lightbox="project" data-title="Develop Project Management Strategy for Governmental Organizations">
                        <img src="../../../assets/images/projects/project3.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName">Develop Project Management Strategy for Governmental Organizations</div>
                            <div class="row m0 projectType">Develop Project Management</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project3.png" data-lightbox="project" data-title="Develop Project Management Strategy for Governmental Organizations" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=3" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
                <div class="project DPM">
                    <a href="../../../assets/images/projects/project4.png" data-lightbox="project" data-title="Develop a Strategy for Contractors Classification System">
                        <img src="../../../assets/images/projects/project4.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName">Develop a Strategy for Contractors Classification System</div>
                            <div class="row m0 projectType">Develop Project Management</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project4.png" data-lightbox="project" data-title="Develop a Strategy for Contractors Classification System" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=4" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
                <div class="project PM">
                    <a href="../../../assets/images/projects/project5.png" data-lightbox="project" data-title="Develop Project Management Unit (PMU) for MOMRA">
                        <img src="../../../assets/images/projects/project5.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName">Develop Project Management Unit (PMU) for MOMRA</div>
                            <div class="row m0 projectType">Project Management</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project5.png" data-lightbox="project" data-title="Develop Project Management Unit (PMU) for MOMRA" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=5" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
                <div class="project PM">
                    <a href="../../../assets/images/projects/project6.png" data-lightbox="project" data-title="Contribution to the Development of PMI International Standards">
                        <img src="../../../assets/images/projects/project6.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName"> Contribution to the Development of "PMI International Standards"</div>
                            <div class="row m0 projectType">Project Management</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project6.png" data-lightbox="project" data-title="Contribution to the Development of PMI International Standards" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=6" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>

                <div class="project CM">
                    <a href="../../../assets/images/projects/project7.png" data-lightbox="project" data-title="Develop Construction and Demolition (C&D) Waste Management Strategy for Egypt">
                        <img src="../../../assets/images/projects/project7.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName"> Develop Construction and Demolition (C&D) Waste Management Strategy for Egypt</div>
                            <div class="row m0 projectType">Construction Management</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project7.png" data-lightbox="project" data-title="Develop Construction and Demolition (C&D) Waste Management Strategy for Egypt" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=7" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
                <div class="project GB">
                    <a href="../../../assets/images/projects/project8.png" data-lightbox="project" data-title="Develop Green Buildings Rating System
                                for Egypt">
                        <img src="../../../assets/images/projects/project8.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName">
                                Develop Green Buildings Rating System
                                for Egypt
                            </div>
                            <div class="row m0 projectType">Green Buildings</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project8.png" data-lightbox="project" data-title="Develop Green Buildings Rating System
                                for Egypt" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=8" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
                <div class="project FM">
                    <a href="../../../assets/images/projects/project9.png" data-lightbox="project" data-title="Develop Public Buildings Operation and Maintenance Code">
                        <img src="../../../assets/images/projects/project9.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName"> Develop Public Buildings Operation and Maintenance Code</div>
                            <div class="row m0 projectType">Facility Management</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project9.png" data-lightbox="project" data-title="Develop Public Buildings Operation and Maintenance Code" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=9" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
                <div class="project FM">
                    <a href="../../../assets/images/projects/project10.png" data-lightbox="project" data-title="“Performance Based” Facility Management Applications">
                        <img src="../../../assets/images/projects/project10.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName"> “Performance Based” Facility Management Applications</div>
                            <div class="row m0 projectType">Facility Management</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project10.png" data-lightbox="project" data-title="“Performance Based” Facility Management Applications" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=10" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
                <div class="project VOR">
                    <a href="../../../assets/images/projects/project11.png" data-lightbox="project" data-title="Kingdom’s Vision 2030 Implementation and Realization Through Vision Realization Initiatives">
                        <img src="../../../assets/images/projects/project11.png" alt="Project 1" class="projectImg">
                    </a>
                    <div class="projectDetails row m0">
                        <div class="fleft nameType">
                            <div class="row m0 projectName"> Kingdom’s Vision 2030 Implementation and Realization Through Vision Realization Initiatives</div>
                            <div class="row m0 projectType">VOR 2030</div>
                        </div>
                        <div class="fright projectIcons btn-group" role="group">
                            <a href="../../../assets/images/projects/project11.png" data-lightbox="project" data-title="Kingdom’s Vision 2030 Implementation and Realization Through Vision Realization Initiatives" class="btn btn-default"><i class="fa fa-search"></i></a>
                            <a href="Project.html?ProjectId=11" class="btn btn-default"><i class="fa fa-file-o"></i></a>
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="row paginationRow m0 leftPos">
                <div class="paginationInner m0 row">
                    <ul class="pagination">
                        <li class="active"><a href="#">1</a></li>
                        <li><a href="#">2</a></li>
                        <li><a href="#">3</a></li>
                    </ul>
                </div>
            </div>-->
        </div>
    </div>
</section> <!--Projects-->